/*
  Builds the mobile drawer's announcement bar and header nav row by cloning
  the real ones at runtime, instead of hand-authoring second copies in
  Liquid. This guarantees identical height/padding/sizing/content between
  the drawer and the live page - they are, structurally, the same markup -
  rather than separate copies that can silently drift apart.

  One thing in the header clone is swapped out, since a straight clone would
  be wrong for it specifically: the mobile-menu trigger (hamburger/close) is
  a stateful component instance (hh-details-modal) that owns this exact
  drawer's open/closed state. A cloned copy of it would be a second,
  disconnected instance - clicking it would do nothing. It's replaced with a
  plain [data-close] button in the same position.

  The account and cart icons need no such swap - they're rendered directly
  in the real nav row (mobile-only, lg:hidden - see sections/header.liquid)
  precisely so that cloning this row carries them into the drawer's top bar
  automatically, the same as the logo and search icon, instead of needing a
  second copy of that markup pulled in from elsewhere.
*/
document.addEventListener('DOMContentLoaded', () => {
  cloneAnnouncementBar()
  cloneHeaderNavRow()
})

function cloneAnnouncementBar() {
  const source = document.querySelector('.js-announcement-bar')
  const target = document.querySelector('.js-mobile-menu-announcement-clone')
  if (!source || !target) return

  const clone = source.cloneNode(true)
  clone.removeAttribute('id')
  target.replaceWith(clone)
}

function cloneHeaderNavRow() {
  const source = document.querySelector('.js-header-nav-row')
  const target = document.querySelector('.js-mobile-menu-top-bar')
  if (!source || !target) return

  const clone = source.cloneNode(true)
  clone.removeAttribute('id')

  const menuTrigger = clone.querySelector('.mobile-menu')
  if (menuTrigger) {
    const closeIcon = menuTrigger.querySelector('.icon-close')
    const closeButton = document.createElement('button')
    closeButton.type = 'button'
    closeButton.dataset.close = ''
    // Same box/sizing pattern as the search/account icons elsewhere in this
    // row, so the substituted close icon matches them instead of rendering
    // at its raw intrinsic SVG size.
    closeButton.className = 'flex items-center justify-center w-xl h-xl p-0 bg-transparent border-0'
    closeButton.setAttribute('aria-label', closeIcon?.getAttribute('aria-label') || '')
    closeButton.innerHTML = closeIcon?.innerHTML || ''
    menuTrigger.replaceWith(closeButton)
  }

  // The account/cart icons (and everything else in this row) come along
  // for free as part of the clone now - but their ids (e.g. the cart
  // button's visually-hidden label) would otherwise be duplicated on the
  // page alongside the real row's.
  clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'))

  // Replace the placeholder itself with the clone (not: insert the clone
  // inside the placeholder) - the cloned header IS the top bar, it
  // shouldn't sit wrapped inside an extra parent div.
  //
  // The thick black divider between this top bar and the accordion list
  // below lives here (on the clone only, via border-b) rather than as a
  // border-t on the scrollable accordion area - this element is part of
  // the header clone, not the accordions.
  clone.classList.add('border-b-[12px]', 'border-brand-black')
  target.replaceWith(clone)
}
